import { useQuery } from '@tanstack/react-query';
import { getUserPhoto, getUserPhotoPortal, UserKeys } from '../api/users-api';

import Avatar from '@mui/material/Avatar';
import type { AvatarProps } from '@mui/material/Avatar';
interface UserAvatarProps extends Omit<AvatarProps, 'src'> {
  userEmail: string;
  isUserPortal?: boolean;
}

export default function UserAvatar({
  userEmail,
  isUserPortal,
  ...avatarProps
}: UserAvatarProps) {
  const { data: imageSrc = '' } = useQuery({
    queryKey: [
      isUserPortal ? UserKeys.UserPhotoPortal : UserKeys.UserPhoto,
      userEmail,
    ],
    queryFn: () =>
      isUserPortal ? getUserPhotoPortal(userEmail) : getUserPhoto(userEmail),
    staleTime: 0,
    enabled: !!userEmail,
  });

  return (
    <Avatar
      src={imageSrc}
      sx={{
        ...(!imageSrc
          ? {
              bgcolor: 'primary.main',
              color: 'common.white',
            }
          : {}),
        ...avatarProps.sx,
      }}
      {...avatarProps}
    />
  );
}
